import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import UpdatePassword from '../updatePassword';

import { addLocale } from '../misc';
import request, {apiHost} from '../utils/request';
import { directAccessConfigs } from '../utils/directAccessConfig';

const PrivateRoute = ({ locale, component: Component, ...rest }) => {
  const token = localStorage.accessToken;
  const currentUrl = window.location.pathname;
  const addLocaleToUrl = addLocale(locale);
  const isPasswordChangeRequired = request.getPasswordUpdate();

  const checkRedirectPage = (props) => {
    const { pathname, search } = props.location;
    if (!token && pathname.includes('report-an-issue') && search !== '') {
      localStorage.setItem('moveToDefects', JSON.stringify(props.location));
    }
  };

  // Generic logic to set redirectAfterLogin if user is not logged in and visits direct URL
  if (!token) {
    const matchedConfig = Object.values(directAccessConfigs).find(config =>
      config.directUrls.includes(currentUrl)
    );
  
    // if (matchedConfig) {
    //   localStorage.setItem('redirectAfterLogin', matchedConfig.webformUrls[locale] || '/');
    //   localStorage.setItem('isRedirectValid', true);
    // }
    if (matchedConfig && matchedConfig.webformUrls && matchedConfig.webformUrls[locale]) {
      localStorage.setItem('redirectAfterLogin', matchedConfig.webformUrls[locale]);
      localStorage.setItem('isRedirectValid', true);
    }    
  }

  const getRoute = props => {
    checkRedirectPage(props);
    const { pathname, search } = props.location;

    // Generic redirect for any direct access URL
    const matchedConfig = Object.values(directAccessConfigs).find(config =>
      config.directUrls.includes(pathname)
    );
    const matchedConfigCurrent = Object.values(directAccessConfigs).find(config =>
      config.directUrls.includes(currentUrl)
    );

    if (!token && matchedConfigCurrent) {
      localStorage.setItem('redirectAfterLogin', matchedConfigCurrent.webformUrls[locale] || '/');
      localStorage.setItem('isRedirectValid', true); 
      // Hard redirect 
      window.location.replace(`${apiHost}/users/sso-login`);
      return null;
    }
    
    if (token && matchedConfig) {
      const target = matchedConfig.webformUrls[locale] || '/';
      return <Redirect to={target} />;
    }
    if (token) {
      return isPasswordChangeRequired ? (
        <Route
          {...rest}
          path={addLocaleToUrl('/update-password')}
          component={UpdatePassword}
        />
      ) : (
        <Component {...props} locale={locale} />
      );
    }
    return <Redirect to={addLocaleToUrl('/login')} />;
  };
  return <Route {...rest} render={props => getRoute(props)} />;
};

PrivateRoute.propTypes = {
  locale: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired
};

export default PrivateRoute;
